const TableSkeleton = () => (
  <div className="animate-pulse md:px-[40px] w-full mx-auto px-4">
    <div className="flex w-full my-3 space-x-3">
      <div className="h-[40px] w-2/12 mt-3 bg-gray-200" />
      <div className="h-[40px] w-2/12 mt-3 bg-gray-200" />
      <div className="h-[40px] w-2/12 mt-3 bg-gray-200" />
      <div className="h-[40px] w-2/12 mt-3 bg-gray-200" />
      <div className="h-[40px] w-2/12 mt-3 bg-gray-200" />
      <div className="h-[40px] w-2/12 mt-3 bg-gray-200" />
    </div>
    {Array.from(Array(7).keys()).map((row: number) => (
      <div
        key={`item-${row}`}
        className="w-full space-x-3 flex border-t-2 border-gray-200"
      >
        <div className="h-[30px] w-2/12 my-2 bg-gray-200" />
        <div className="h-[30px] w-2/12 my-2 bg-gray-200" />
        <div className="h-[30px] w-2/12 my-2 bg-gray-200" />
        <div className="h-[30px] w-2/12 my-2 bg-gray-200" />
        <div className="h-[30px] w-2/12 my-2 bg-gray-200" />
        <div className="h-[30px] w-2/12 my-2 bg-gray-200" />
      </div>
    ))}
  </div>
);

export default TableSkeleton;
